import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const CodeBlockIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.45708 3.78512C9.52818 3.42972 9.29771 3.08398 8.94232 3.01288C8.58692 2.94178 8.24118 3.17224 8.17008 3.52763L6.53808 11.685C6.46698 12.0403 6.69744 12.3861 7.05284 12.4572C7.40823 12.5283 7.75397 12.2978 7.82508 11.9424L9.45708 3.78512ZM4.44437 4.89378C4.66182 5.18374 4.60304 5.59507 4.31308 5.81252L1.75006 7.73461L4.31308 9.6567C4.60304 9.87415 4.66182 10.2855 4.44437 10.5754C4.22692 10.8654 3.81559 10.9242 3.52563 10.7067L0.262523 8.25963C0.0972618 8.1357 0 7.94118 0 7.73461C0 7.52804 0.0972618 7.33353 0.262523 7.2096L3.52563 4.76249C3.81559 4.54504 4.22692 4.60382 4.44437 4.89378ZM11.5508 4.89378C11.7682 4.60382 12.1796 4.54504 12.4695 4.76249L15.7326 7.2096C15.8979 7.33353 15.9952 7.52804 15.9952 7.73461C15.9952 7.94118 15.8979 8.1357 15.7326 8.25963L12.4695 10.7067C12.1796 10.9242 11.7682 10.8654 11.5508 10.5754C11.3333 10.2855 11.3921 9.87415 11.6821 9.6567L14.2451 7.73461L11.6821 5.81252C11.3921 5.59507 11.3333 5.18374 11.5508 4.89378Z"
		></path>
	</svg>
))
